import React from "react";
import { Star } from "lucide-react";

export default function TestimonialTile({ testimonial, active, onSelect }) {
  const rating = testimonial.rating || 5;
  return (
    <button
      onClick={onSelect}
      className={`text-left p-4 border transition-all ${
        active
          ? "bg-neutral-900 text-[#fbf3e4] border-neutral-900"
          : "bg-white border-neutral-200 hover:border-neutral-900"
      }`}
    >
      <div className="flex gap-0.5 mb-2">
        {[...Array(rating)].map((_, s) => (
          <Star
            key={`${testimonial.id}-tile-star-${s}`}
            size={10}
            className={active ? "fill-[#fbf3e4] text-[#fbf3e4]" : "fill-neutral-900 text-neutral-900"}
          />
        ))}
      </div>
      <div className={`text-xs font-medium truncate ${active ? "text-[#fbf3e4]" : "text-neutral-900"}`}>
        {testimonial.author}
      </div>
      <div className={`text-[10px] tracking-wider mt-1 truncate ${active ? "text-neutral-400" : "text-neutral-500"}`}>
        {testimonial.role}
      </div>
    </button>
  );
}
